import {call, put, takeLatest, fork, all, delay,} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as SiteInfoService from './../services/siteInfoService';

import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {PATHS, SAGA_DELAY_TIMEOUT} from '../constants/Define';
import { parseRatingListRequestParams } from '../utils/commonUtils';
import { notification } from 'antd'
import {
    setListInfos as setListSiteInfosAction,
    setSiteInfoDetail as setSiteInfoDetailAction,
} from './../actions/siteInfoAction';
import history from './../helpers/history';

function* getListSiteInfo() {
    yield takeLatest(Types.SITEINFO_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const pageSize = action.filters.pageSize ? action.filters.pageSize > 10 ? action.filters.pageSize : undefined : undefined;
        const pageIndex = action.filters.pageIndex ? action.filters.pageIndex > 1 ? action.filters.pageIndex : undefined : undefined;
        const params = {
            ...action.filters,
            pageSize, pageIndex,
        };
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(SiteInfoService.getSiteInfo, params);
        yield put(setListSiteInfosAction(result));
    }, errorHandleSiteInfo(Types.SITEINFO_LIST_FAIL)))
}

function* getSiteInfoDetail() {
    yield takeLatest(Types.SITEINFO_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(SiteInfoService.getSiteInfoDetail, action.id);
        yield put(setSiteInfoDetailAction(result));
    }, errorHandleSiteInfo(Types.SITEINFO_DETAIL_FAIL)))
}

function* updateSiteInfoDetail() {
    yield takeLatest(Types.SITEINFO_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(SiteInfoService.updateSiteInfoDetail, action.siteinfo.siteinfo);
        successHandleSiteInfo(action, action.siteinfo.siteinfo.name);
        yield put(setSiteInfoDetailAction(action.siteinfo.siteinfo));
        history.push(PATHS.SITEINFO.LIST.path);
        history.go();
    }, errorHandleSiteInfo(Types.SITEINFO_DETAIL_FAIL)))
}

function* createSiteInfoDetail() {
    yield takeLatest(Types.SITEINFO_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const result = yield call(SiteInfoService.createSiteInfoDetail, action.siteinfo);
        successHandleSiteInfo(action, action.siteinfo.name);
        yield put(setSiteInfoDetailAction(result));
        history.push(PATHS.SITEINFO.LIST.path);
        history.go();
    }, errorHandleSiteInfo(Types.SITEINFO_DETAIL_FAIL)))
}

function* deleteSiteInfoDetail() {
    yield takeLatest(Types.SITEINFO_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(SiteInfoService.deleteSiteInfoDetail, action.siteinfo);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.removeSuccess')}`,
        });
        const params = parseRatingListRequestParams(action.filter || {});
        const resultList = yield call(SiteInfoService.getSiteInfo, params);
        yield put(setListSiteInfosAction(resultList));
    }, errorHandleSiteInfo(Types.SITEINFO_DETAIL_FAIL)));
}


/* Transtale Saga */

function* createSiteInfoTranslate() {
    yield takeLatest(Types.SITEINFO_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(SiteInfoService.createSiteInfoTranslate, action.siteinfo);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.siteinfo.translate.languageName);
        yield put({ type: Types.SITEINFO_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.SITEINFO_DETAIL_ACTION, id: action.siteinfo.id });
    }, errorHandleSiteInfo(Types.SITEINFO_FAIL)))
}

function* updateSiteInfoTranslate() {
    yield takeLatest(Types.SITEINFO_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(SiteInfoService.updateSiteInfoTranslate, action.siteinfo);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.siteinfo.translate.languageName);
        yield put({ type: Types.SITEINFO_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.SITEINFO_DETAIL_ACTION, id: action.siteinfo.id });
    }, errorHandleSiteInfo(Types.SITEINFO_FAIL)))
}

function* deleteSiteInfoTranslate() {
    yield takeLatest(Types.SITEINFO_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(SiteInfoService.deleteSiteInfoTranslate, action.siteinfo.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.siteinfo.translate.languageName);
        yield put({ type: Types.SITEINFO_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.SITEINFO_DETAIL_ACTION, id: action.siteinfo.id });
    }, errorHandleSiteInfo(Types.SITEINFO_FAIL)))
}

function successHandleSiteInfo(action, value) {
    return Func.sagaSuccessMessage({
        action,
        message: `${i18n.t('notification.createSuccess')}`,
        description: `${i18n.t('item.siteinfo.title')} "${value}"`
    })
}


function errorHandleSiteInfo(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'siteInfo');
}

export function* siteInfoSaga() {
    yield all([
        fork(getListSiteInfo),
        fork(getSiteInfoDetail),
        fork(updateSiteInfoDetail),
        fork(createSiteInfoDetail),
        fork(createSiteInfoTranslate),
        fork(updateSiteInfoTranslate),
        fork(deleteSiteInfoDetail),
        fork(deleteSiteInfoTranslate)
    ])
}
